export default __webpack_public_path__ + "static/media/photo.ae1b0cf4.svg";